"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mallDomain = void 0;
var qs = require('qs');
exports.mallDomain = function (axios) {
    return {
        getDomainsByMallNo: function (request) {
            var query = qs.stringify(request);
            return axios.get("/domains?" + query);
        },
        getDomainByMalls: function () {
            return axios.get('/domains/by-malls');
        },
        getDomainsExist: function (request) {
            var query = qs.stringify(request);
            return axios.get("/domains/exist/?" + query);
        },
        putDomainsDomainNoRequest: function (request) {
            return axios.put("/domains/" + request.pathParams.domainNo, request.data);
        },
        getDomainsValidate: function (request) {
            return axios.get('/domains/validate', request);
        },
    };
};
